import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';

const Card = ({ data = {} }) => {
  const {
    image,
    heading: number1,
    text: desc1,
    heading2: number2,
    text2: desc2,
    variation,
    width,
  } = data;

  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderNumber1 = !!number1?.value;
  const shouldRenderDesc1 = !!desc1?.value;
  const shouldRenderNumber2 = !!number2?.value;
  const shouldRenderDesc2 = !!desc2?.value;
  const widthVariation = width?.fields?.DropdownValue?.value;
  const alignmentVariation = variation?.fields?.DropdownValue?.value;

  return (
    <div
      className={clsx(
        'infographic-item col-12',
        widthVariation === '6' ? 'col-lg-6 two-colmns' : 'one-column'
      )}
    >
      <div
        className={clsx(
          'row infographic-item-wrapper',
          alignmentVariation === 'imageAtTheRight' && 'image-right'
        )}
      >
        <div className="col-10 image-wrapper">
          {shouldRenderImage && <Image className="infographic-image" field={image} />}
        </div>
        <div className="infographic-card col-8 col-sm-6">
          {shouldRenderNumber1 && (
            <div className="infographic-number-one">
              <Text field={number1} />
            </div>
          )}
          {shouldRenderDesc1 && <RichText field={desc1} className="infographic-number-desc-one" />}
          {shouldRenderNumber2 && (
            <div className="infographic-number-two">
              <Text field={number2} />
            </div>
          )}
          {shouldRenderDesc2 && <RichText field={desc2} className="infographic-number-desc-two" />}
        </div>
      </div>
    </div>
  );
};

export default Card;
